"use strict";

var StringUtils = function StringUtils() {
  /* THIS FIX */
  var _this = this;

  /* PUBLIC VARIABLES */
  _this.url = null;

  /* PRIVATE VARIABLES */

  /* PUBLIC FUNCTIONS */
  _this.escapeHtml = function (text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#039;'
    };
    return text.replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  };

  /* INITs FUNCTIONS */
  function _construct() {
    init();
  }
  function init() {
    if (!_this.inited) {
      _this.inited = true;
    }
  }

  /* INIT CONSTRUCTOR */
  _construct();
};